import { render, staticRenderFns } from "./Configuration.vue?vue&type=template&id=8c4e2eac&scoped=true&"
import script from "./Configuration.vue?vue&type=script&lang=js&"
export * from "./Configuration.vue?vue&type=script&lang=js&"
import style0 from "./Configuration.vue?vue&type=style&index=0&id=8c4e2eac&prod&lang=scss&"
import style1 from "./Configuration.vue?vue&type=style&index=1&id=8c4e2eac&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c4e2eac",
  null
  
)

export default component.exports